/* ======= NOTE: On variant change: Managing Engraving toggle ON/OFF price logic is handled in **rc-global-variables-pdp.liquid** file ======= */

(function () {
  /* ======= Placement / Style option config maps ======= */
  /* ======= style-option rules  (tag: engraving-style-option + Engravable-placement) ======= */
  var STYLE_OPTION_RULES = {
    'Right Vertical': { line1: 12, line2: null },
    'Center':         { line1: 12, line2: 12   }
  };

  /* ======= placement-option rules  (tag: engraving-placement-option + Engravable-placement) ======= */
  var PLACEMENT_OPTION_RULES = {
    'Right Vertical':       { line1: 13, line2: null },
    'Center- 1 Line':       { line1: 10, line2: null },
    'Center- 2 Lines':      { line1: 7,  line2: 10  },
    'Bottom Right- 1 Line': { line1: 4,  line2: null },
    'Bottom Right- 2 Lines':{ line1: 2,  line2: 4   }
  };

  /* ======= vert-hor-option rules  (tag: engraving-vert-hor-options)
     "Vertical with Center Dot" is the only layout that uses a second/third box;
     "Vertical Text" and "Horizontal Text" are single-box layouts with their own max length. ======= */
  var VERT_HOR_OPTION_RULES = {
    'Vertical with Center Dot': { line1: 2, line2: 2,    line3: 2 },
    'Vertical Text':     { line1: 4, line2: null, line3: null },
    'Horizontal Text':   { line1: 6, line2: null, line3: null }
  };

  /* ======= Global engraving image data store
    Consumed by rc-dynamic-image-integration.js → fetchEngravingImage()
    Shape: { font, placement, stoneShape } ======= */
  window.__rcEngravingImageData = window.__rcEngravingImageData || {
    font:       '',
    placement:  '',
    stoneShape: ''
  };

  /* ======= Dispatch a custom event so rc-dynamic-image-integration.js can react without coupling directly to this file. ======= */
  function dispatchEngravingSelectionChanged() {
    document.dispatchEvent(new CustomEvent('rc:engraving:selectionChanged'));
  }

  /* ======= Resolve the ONE <form> this engraving config should read/write to, scoped by section id.  ======= */
  function getEngravingForm(sectionId) {
    const scopedProductForm = document.querySelector(`product-form[data-section="${sectionId}"]`);
    const scopedForm = scopedProductForm ? scopedProductForm.querySelector('form') : null;
    return scopedForm || document.querySelector('form.form[action="/cart/add"]');
  }

  /* ======= Toggle Handler ======= */
  function initEngravingToggle(configEl) {
    const sectionId      = configEl.dataset.sectionId;
    const placementMode  = configEl.dataset.placementMode || 'none';
    const defaultMax     = parseInt(configEl.dataset.maxLength) || 20;
    // ====== Side B max length (used by engraving-side-options mode) ======
    // NOTE: reads data-max-length-b (NOT data-max-length-2) — a hyphen followed by a digit is never camelCased by the browser's dataset algorithm,
    // so dataset.maxLength2 would always be undefined for a data-max-length-2 attribute.
    const defaultMax2    = parseInt(configEl.dataset.maxLengthB) || defaultMax;
    const toggle         = document.getElementById(`engraving-toggle-${sectionId}`);
    const block          = document.getElementById(`engraving-block-${sectionId}`);
    const input          = document.getElementById(`engraving-text-${sectionId}`);
    const input2         = document.getElementById(`engraving-text2-${sectionId}`);
    const input3         = document.getElementById(`engraving-text3-${sectionId}`);
    const preview        = document.getElementById(`engraving-preview-${sectionId}`);
    const preview2       = document.getElementById(`engraving-preview2-${sectionId}`);
    const preview3       = document.getElementById(`engraving-preview3-${sectionId}`);
    const previewWrapper  = document.getElementById(`engraving-preview-wrapper-${sectionId}`);
    const previewWrapper2 = document.getElementById(`engraving-preview-wrapper2-${sectionId}`);
    const previewWrapper3 = document.getElementById(`engraving-preview-wrapper3-${sectionId}`);
    const count          = document.getElementById(`engraving-count-${sectionId}`);

    // ====== Seed stoneShape from config data attribute (set in Liquid via Shape- tag) ======
    if (configEl.dataset.stoneShape) {
      window.__rcEngravingImageData.stoneShape = configEl.dataset.stoneShape;
    }
    // ====== Seed productId from config data attribute (set in Liquid via productId- tag) ======
    if (configEl.dataset.productId) {
      window.__rcEngravingImageData.productId = configEl.dataset.productId;
    }
    // ====== Seed leadtime note override from config data attribute (set in Liquid via the Leadtime: tag).
    //        updateEngravingLeadTime() falls back to the standard "2-3 weeks" copy if this never gets set. ======
    if (configEl.dataset.leadtimeNote) {
      window.__rcEngravingLeadtimeNote = configEl.dataset.leadtimeNote;
    }

    if (!toggle || !block || !input) return;

    toggle.addEventListener('change', function () {
      const isOn = this.checked;
      window.__rcEngravingToggleState = window.__rcEngravingToggleState || {};
      window.__rcEngravingToggleState[sectionId] = isOn;
      const form = getEngravingForm(sectionId);

      // ====== ATC button Final Sale spans ======
      const finalSaleEl  = document.getElementById(`FinalSaleMsg-${sectionId}`);

      if (isOn) {
        block.classList.remove('engraving-block--disabled');
        block.classList.add('engraving-block--enabled');
        block.setAttribute('aria-hidden', 'false');
        // Only enable primary input immediately for non-dynamic modes.
        // For style-option / placement-option / vert-hor-option the user must pick a placement first.
        if (placementMode !== 'style-option' && placementMode !== 'placement-option' && placementMode !== 'vert-hor-option') {
          input.removeAttribute('disabled');
          // ====== side-option mode: both sides enable together, no placement gate ======
          if (placementMode === 'side-option' && input2) {
            input2.removeAttribute('disabled');
          }
        }
        // ====== Notify price snippet ====== 
        document.dispatchEvent(new CustomEvent('engraving:toggled', { detail: { enabled: true } }));
        // ====== Update Leadtime ======
        updateEngravingLeadTime('turned_on');

        // ====== Engraving ON: inject Final_Sale & _excludeFromNarvar property ======
        if (form) {
          // Remove any existing to avoid duplicates
          form.querySelector('input[name="properties[Final_Sale]"]')?.remove();
          const fsInput  = document.createElement('input');
          fsInput.type   = 'hidden';
          fsInput.name   = 'properties[Final_Sale]';
          fsInput.value  = '(Final Sale!)';
          // Mark it as engraving-owned so variant changes don't accidentally remove it
          fsInput.dataset.source = 'engraving';
          form.appendChild(fsInput);

          // Remove any existing to avoid duplicates
          form.querySelector('input[name="properties[_excludeFromNarvar]"]')?.remove();
          const narvarInput  = document.createElement('input');
          narvarInput.type   = 'hidden';
          narvarInput.name   = 'properties[_excludeFromNarvar]';
          narvarInput.value  = 'yes';
          // Mark it as engraving-owned so variant changes don't accidentally remove it
          narvarInput.dataset.source = 'engraving';
          form.appendChild(narvarInput);
        }

        if (finalSaleEl) {
          finalSaleEl.textContent       = ' (FINAL SALE!)';
          finalSaleEl.dataset.available = 'true';
          finalSaleEl.dataset.engravingFinalSale = 'true'; // ← sentinel flag
        }

        // ====== side-option mode: flag the line item so the cart properties
        // snippet knows to label Engraving_Text/_Font as Side A/B ======
        if (placementMode === 'side-option' && form) {
          form.querySelector('input[name="properties[_engravingSideOptions]"]')?.remove();
          const sideOptInput  = document.createElement('input');
          sideOptInput.type   = 'hidden';
          sideOptInput.name   = 'properties[_engravingSideOptions]';
          sideOptInput.value  = 'true';
          form.appendChild(sideOptInput);
        }

      } else {
        block.classList.remove('engraving-block--enabled');
        block.classList.add('engraving-block--disabled');
        block.setAttribute('aria-hidden', 'true');
        input.setAttribute('disabled', 'disabled');
        // ====== Update Leadtime ======
        updateEngravingLeadTime('turned_off');

        // ====== Reset primary input ======
        input.value       = '';
        count.textContent = '0';

        // ====== Reset secondary input ======
        if (input2) {
          input2.value = '';
          input2.setAttribute('disabled', 'disabled');
          const count2 = document.getElementById(`engraving-count2-${sectionId}`);
          if (count2) count2.textContent = '0';
          // ====== side-option mode keeps Side B visible (just disabled/greyed via block class) ======
          const wrapper2 = document.getElementById(`engraving-text2-wrapper-${sectionId}`);
          if (wrapper2 && placementMode !== 'side-option') wrapper2.style.display = 'none';
        }

        // ====== Reset third input (vert-hor-option mode only — "Vertical with Center Dot" third box) ======
        if (input3) {
          input3.value = '';
          input3.setAttribute('disabled', 'disabled');
          const count3 = document.getElementById(`engraving-count3-${sectionId}`);
          if (count3) count3.textContent = '0';
          const wrapper3 = document.getElementById(`engraving-text3-wrapper-${sectionId}`);
          if (wrapper3) wrapper3.style.display = 'none';
        }

        // ====== Reset all three previews independently ======
        if (previewWrapper)  previewWrapper.style.display  = 'none';
        if (preview)         preview.textContent           = '';
        if (previewWrapper2) previewWrapper2.style.display = 'none';
        if (preview2)        preview2.textContent          = '';
        if (previewWrapper3) previewWrapper3.style.display = 'none';
        if (preview3)        preview3.textContent          = '';

        // ====== Reset only our engraving dropdowns (identified by wrapper divs) ======
        block.querySelectorAll('[data-engraving-dropdown]').forEach(function (wrapper) {
          const dd = wrapper.querySelector('.custom-dropdown');
          if (!dd) return;
          const label = dd.querySelector('.custom-dropdown__label');
          if (label) label.textContent = 'Select';
          dd.querySelectorAll('.custom-dropdown__option').forEach(function (o) {
            o.classList.remove('is-active');
          });
        });

        // ====== Reset primary input maxlength for dynamic modes ======
        if (placementMode === 'style-option' || placementMode === 'placement-option' || placementMode === 'vert-hor-option') {
          input.setAttribute('maxlength', '0');
          const maxLengthEl = document.getElementById(`engraving-maxlength-${sectionId}`);
          if (maxLengthEl) maxLengthEl.textContent = '0';
        } else if (placementMode === 'side-option') {
          // ====== Side A / Side B keep their own fixed max lengths ======
          input.setAttribute('maxlength', defaultMax);
          const maxLengthEl = document.getElementById(`engraving-maxlength-${sectionId}`);
          if (maxLengthEl) maxLengthEl.textContent = defaultMax;
          if (input2) {
            input2.setAttribute('maxlength', defaultMax2);
            const maxLengthEl2 = document.getElementById(`engraving-maxlength2-${sectionId}`);
            if (maxLengthEl2) maxLengthEl2.textContent = defaultMax2;
          }
        } else {
          input.setAttribute('maxlength', defaultMax);
          const maxLengthEl = document.getElementById(`engraving-maxlength-${sectionId}`);
          if (maxLengthEl) maxLengthEl.textContent = defaultMax;
        }

        // ====== Reset engraving image data (keep stoneShape — it comes from the product, not a selection) ======
        window.__rcEngravingImageData.font      = '';
        window.__rcEngravingImageData.font2     = '';
        window.__rcEngravingImageData.placement = '';

        // ====== Remove cart properties ======
        if (form) {
          form.querySelector('input[name="properties[Engraving_Text]"]')?.remove();
          form.querySelector('input[name="properties[Engraving_Text_2]"]')?.remove();
          form.querySelector('input[name="properties[Engraving_Text_3]"]')?.remove();
          form.querySelector('input[name="properties[Engraving_Font]"]')?.remove();
          form.querySelector('input[name="properties[Engraving_Font_2]"]')?.remove();
          form.querySelector('input[name="properties[_engravingplacement]"]')?.remove();
          form.querySelector('input[name="properties[_engraving_required]"]')?.remove();
          form.querySelector('input[name="properties[_engraving_image]"]')?.remove();
          form.querySelector('input[name="properties[_engravingSideOptions]"]')?.remove();
          form.querySelector('input[name="properties[Final_Sale]"]')?.remove();
          form.querySelector('input[name="properties[_excludeFromNarvar]"]')?.remove();
        }

        // ====== Resetting Final sale state ======
        if (finalSaleEl) {
          finalSaleEl.textContent       = '';
          finalSaleEl.dataset.available = 'false';
          delete finalSaleEl.dataset.engravingFinalSale;
        }

        document.dispatchEvent(new CustomEvent('engraving:toggled', { detail: { enabled: false } }));
      }
    });
  }

  // ====== Update Engraving Leadtime ======
  function updateEngravingLeadTime(toggleStatus) {
    const engravingLeadTimeFromUi = originalLeadTime.replace(/\s+/g, "");
    const leadtimeSwatch = document.getElementById('rc-leadtime-swatch');
    const mainLeadTimeContainer = $('#rc-leadtime-display');
    const mainLeadTimeContainerEngrav = $('#rc-leadtime-display-engraving');
    const engravingDisplayEl = document.getElementById('rc-leadtime-display-engraving');
    // ====== Dynamic leadtime note (tag: Leadtime: <text>, seeded in initEngravingToggle) — falls back to the standard copy ======
    const leadtimeNote = window.__rcEngravingLeadtimeNote || 'Please add an additional 2-3 weeks for engraving.';

    if (!engravingLeadTimeFromUi || !leadtimeSwatch) return;

    const isTurnedOn = toggleStatus === 'turned_on';
    const isSoldOut  = /soldout/i.test(engravingLeadTimeFromUi);
    const isInStock  = /instock|InStock|pieceleft!|piecesleft!|Onlyafewleft!/i.test(engravingLeadTimeFromUi);

    if (isTurnedOn) {
      // ====== Sold out: show plain "Sold Out", no engraving suffix, no swatch ======
      if (isSoldOut) {
        mainLeadTimeContainerEngrav.text(originalLeadTime);
        engravingDisplayEl.hidden = false;
        mainLeadTimeContainer.addClass('is-hide');
        leadtimeSwatch.hidden = true;
        return;
      }

      const swatchClass = isInStock ? 'rc-swatch--green' : 'rc-swatch--orange';
      const swatchLabel = isInStock ? 'In Stock' : 'Made to Order';
      const leadText    = isInStock
        ? `In Stock. ${leadtimeNote}`
        : `${originalLeadTime} ${leadtimeNote}`;

      mainLeadTimeContainerEngrav.text(leadText);
      engravingDisplayEl.hidden = false;
      mainLeadTimeContainer.addClass('is-hide');
      leadtimeSwatch.hidden = false;
      // ====== classList.replace no-ops if the old class isn't present (e.g. coming from sold-out) ======
      leadtimeSwatch.classList.remove('rc-swatch--green', 'rc-swatch--orange');
      leadtimeSwatch.classList.add(swatchClass);
      leadtimeSwatch.innerHTML = `<span class="rc-swatch__dot"></span>${swatchLabel}`;
    } else {
      mainLeadTimeContainerEngrav.text(originalLeadTime);
      engravingDisplayEl.hidden = true;
      mainLeadTimeContainer.removeClass('is-hide');
    }
  }

  // ====== Expose so leadtime script can refresh the engraving display on variant change ======
  window.__rcUpdateEngravingLeadTime = updateEngravingLeadTime;

  // ====== Apply placement/style/vert-hor option rules to inputs ======
  function applyPlacementRules(sectionId, rules) {
    const primaryInput    = document.getElementById(`engraving-text-${sectionId}`);
    const primaryCount    = document.getElementById(`engraving-count-${sectionId}`);
    const primaryMaxEl    = document.getElementById(`engraving-maxlength-${sectionId}`);
    const input2Wrapper   = document.getElementById(`engraving-text2-wrapper-${sectionId}`);
    const input2          = document.getElementById(`engraving-text2-${sectionId}`);
    const count2          = document.getElementById(`engraving-count2-${sectionId}`);
    const maxLengthEl2    = document.getElementById(`engraving-maxlength2-${sectionId}`);
    const previewWrapper2 = document.getElementById(`engraving-preview-wrapper2-${sectionId}`);
    const preview2        = document.getElementById(`engraving-preview2-${sectionId}`);
    // ====== Third input — only present in vert-hor-option mode markup; every lookup below no-ops elsewhere ======
    const input3Wrapper   = document.getElementById(`engraving-text3-wrapper-${sectionId}`);
    const input3          = document.getElementById(`engraving-text3-${sectionId}`);
    const count3          = document.getElementById(`engraving-count3-${sectionId}`);
    const maxLengthEl3    = document.getElementById(`engraving-maxlength3-${sectionId}`);
    const previewWrapper3 = document.getElementById(`engraving-preview-wrapper3-${sectionId}`);
    const preview3        = document.getElementById(`engraving-preview3-${sectionId}`);

    if (!primaryInput || !rules) return;

    // ====== Primary input ======
    primaryInput.setAttribute('maxlength', rules.line1);
    if (primaryMaxEl) primaryMaxEl.textContent = rules.line1;

    // ====== Trim existing value if it exceeds new max ======
    if (primaryInput.value.length > rules.line1) {
      primaryInput.value = primaryInput.value.slice(0, rules.line1);
    }
    if (primaryCount) primaryCount.textContent = primaryInput.value.length;

    // ====== Secondary input ======
    if (rules.line2 !== null && rules.line2 !== undefined) {
      // ====== Show second input wrapper ======
      if (input2Wrapper) input2Wrapper.style.display = '';
      if (input2) {
        input2.setAttribute('maxlength', rules.line2);
        input2.removeAttribute('disabled');
        if (input2.value.length > rules.line2) input2.value = input2.value.slice(0, rules.line2);
        if (count2)      count2.textContent      = input2.value.length;
        if (maxLengthEl2) maxLengthEl2.textContent = rules.line2;
      }
    } else {
      // ====== Hide second input and clear its value ======
      if (input2Wrapper) input2Wrapper.style.display = 'none';
      if (input2) {
        input2.setAttribute('disabled', 'disabled');
        input2.value = '';
        if (count2) count2.textContent = '0';
      }
      // ====== Hide the second preview ======
      if (previewWrapper2) previewWrapper2.style.display = 'none';
      if (preview2) preview2.textContent = '';
      // ====== Remove Engraving_Text_2 from form ======
      const form = getEngravingForm(sectionId);
      if (form) form.querySelector('input[name="properties[Engraving_Text_2]"]')?.remove();
    }

    // ====== Third input (vert-hor-option "Vertical with Center Dot" only) ======
    if (rules.line3 !== null && rules.line3 !== undefined) {
      // ====== Show third input wrapper ======
      if (input3Wrapper) input3Wrapper.style.display = '';
      if (input3) {
        input3.setAttribute('maxlength', rules.line3);
        input3.removeAttribute('disabled');
        if (input3.value.length > rules.line3) input3.value = input3.value.slice(0, rules.line3);
        if (count3)       count3.textContent      = input3.value.length;
        if (maxLengthEl3) maxLengthEl3.textContent = rules.line3;
      }
    } else {
      // ====== Hide third input and clear its value ======
      if (input3Wrapper) input3Wrapper.style.display = 'none';
      if (input3) {
        input3.setAttribute('disabled', 'disabled');
        input3.value = '';
        if (count3) count3.textContent = '0';
      }
      // ====== Hide the third preview ======
      if (previewWrapper3) previewWrapper3.style.display = 'none';
      if (preview3) preview3.textContent = '';
      // ====== Remove Engraving_Text_3 from form ======
      const form = getEngravingForm(sectionId);
      if (form) form.querySelector('input[name="properties[Engraving_Text_3]"]')?.remove();
    }
  }

  // ====== Engraving Input + Font Handler ======
  function initEngraving(configEl) {
    const sectionId      = configEl.dataset.sectionId;
    const placementMode  = configEl.dataset.placementMode || 'none';
    const defaultMax     = parseInt(configEl.dataset.maxLength) || 20;
    // ====== Side B max length (used by engraving-side-options mode) ======
    // NOTE: reads data-max-length-b, see note in initEngravingToggle above.
    const defaultMax2    = parseInt(configEl.dataset.maxLengthB) || defaultMax;

    const input           = document.getElementById(`engraving-text-${sectionId}`);
    const input2          = document.getElementById(`engraving-text2-${sectionId}`);
    const input3          = document.getElementById(`engraving-text3-${sectionId}`);
    const preview         = document.getElementById(`engraving-preview-${sectionId}`);
    const preview2        = document.getElementById(`engraving-preview2-${sectionId}`);
    const preview3        = document.getElementById(`engraving-preview3-${sectionId}`);
    const previewWrapper  = document.getElementById(`engraving-preview-wrapper-${sectionId}`);
    const previewWrapper2 = document.getElementById(`engraving-preview-wrapper2-${sectionId}`);
    const previewWrapper3 = document.getElementById(`engraving-preview-wrapper3-${sectionId}`);
    const count           = document.getElementById(`engraving-count-${sectionId}`);
    const block           = document.getElementById(`engraving-block-${sectionId}`);
    const toggle          = document.getElementById(`engraving-toggle-${sectionId}`);

    if (!input || !preview || !block) {
      console.warn('[Engraving] Missing elements for section', sectionId);
      return;
    }

    // ====== Set initial maxlength ======
    const hasDynamicMax = (placementMode === 'style-option' || placementMode === 'placement-option' || placementMode === 'vert-hor-option');
    input.setAttribute('maxlength', hasDynamicMax ? 0 : defaultMax);

    const primaryMaxEl = document.getElementById(`engraving-maxlength-${sectionId}`);
    if (primaryMaxEl) primaryMaxEl.textContent = hasDynamicMax ? 0 : defaultMax;

    // ====== side-option mode: Side B gets its own fixed max length from the start ======
    if (placementMode === 'side-option' && input2) {
      input2.setAttribute('maxlength', defaultMax2);
      const maxLengthEl2 = document.getElementById(`engraving-maxlength2-${sectionId}`);
      if (maxLengthEl2) maxLengthEl2.textContent = defaultMax2;
    }

    // ====== Font tracking — Side A / primary ======
    let selectedFont    = null;
    let selectedFontKey = null;

    // ====== Font tracking — Side B (only used in side-option mode) ======
    let selectedFont2    = null;
    let selectedFontKey2 = null;

    function isCelineFont() {
      if (!selectedFontKey) return false;
      const key = String(selectedFontKey).toLowerCase().replace(/[\s\-_]/g, '');
      return key === 'celine';
    }
    function isCelineFont2() {
      if (!selectedFontKey2) return false;
      const key = String(selectedFontKey2).toLowerCase().replace(/[\s\-_]/g, '');
      return key === 'celine';
    }
    function previewDisplayText(raw) {
      return isCelineFont() ? raw.toUpperCase() : raw;
    }
    function previewDisplayText2(raw) {
      return isCelineFont2() ? raw.toUpperCase() : raw;
    }

    // ====== Placement / Style / Vert-Hor Dropdown listener ======
    if (placementMode === 'style-option' || placementMode === 'placement-option' || placementMode === 'vert-hor-option') {
      const rulesMap = placementMode === 'style-option'
        ? STYLE_OPTION_RULES
        : placementMode === 'placement-option'
          ? PLACEMENT_OPTION_RULES
          : VERT_HOR_OPTION_RULES;

      const placementPropName   = placementMode === 'style-option' ? 'Engraving_Style' : 'Engraving_Placement';
      const placementWrapper    = block.querySelector(`[data-engraving-dropdown="${placementPropName}"]`);
      const placementDropdownEl = placementWrapper ? placementWrapper.querySelector('.custom-dropdown') : null;

      if (placementDropdownEl) {
        placementDropdownEl.addEventListener('click', function (e) {
          const option = e.target.closest('.custom-dropdown__option');
          if (!option) return;
          clearNativeError('js-engraving-placement-error');

          const chosen = option.dataset.value;
          const rules  = rulesMap[chosen];

          if (rules) {
            applyPlacementRules(sectionId, rules);
            // ====== Re-enable primary input now that a selection has been made ======
            input.removeAttribute('disabled');

            // ====== Re-run each visible input's own 'input' handler ======
            input.dispatchEvent(new Event('input'));
            if (input2) input2.dispatchEvent(new Event('input'));
            if (input3) input3.dispatchEvent(new Event('input'));
          }

          placementDropdownEl.querySelectorAll('.custom-dropdown__option').forEach(o => o.classList.remove('is-active'));
          option.classList.add('is-active');

          const label = placementDropdownEl.querySelector('.custom-dropdown__label');
          if (label) label.textContent = chosen;

          // ====== Always write to unified _engravingplacement property ======
          syncPropertyToForm('_engravingplacement', chosen);

          // ====== Dynamic image: update placement and fire event ======
          window.__rcEngravingImageData.placement = chosen;
          dispatchEngravingSelectionChanged();
        });
      }
    }

    // ====== After the style-option/placement-option/vert-hor-option if-block — handles basic mode too
    if (placementMode === 'basic') {
      const placementWrapper    = block.querySelector('[data-engraving-dropdown="Engraving_Placement"]');
      const placementDropdownEl = placementWrapper?.querySelector('.custom-dropdown');

      if (placementDropdownEl) {
        placementDropdownEl.addEventListener('click', function (e) {
          const option = e.target.closest('.custom-dropdown__option');
          if (!option) return;
          const chosen = option.dataset.value;

          placementDropdownEl.querySelectorAll('.custom-dropdown__option')
            .forEach(o => o.classList.remove('is-active'));
          option.classList.add('is-active');
          const label = placementDropdownEl.querySelector('.custom-dropdown__label');
          if (label) label.textContent = chosen;

          // ====== Always write to unified _engravingplacement property ======
          syncPropertyToForm('_engravingplacement', chosen);

          // ====== Dynamic image: update placement and fire event ======
          window.__rcEngravingImageData.placement = chosen;
          dispatchEngravingSelectionChanged();
        });
      }
    }

    // ====== Font Dropdown listener — Side A / primary (Engraving_Font) ======
    const fontWrapper         = block.querySelector('[data-engraving-dropdown="Engraving_Font"]');
    const correctFontDropdown = fontWrapper ? fontWrapper.querySelector('.custom-dropdown') : null;

    if (correctFontDropdown) {
      const label = correctFontDropdown.querySelector('.custom-dropdown__label');
      if (label) label.textContent = 'Select';
      correctFontDropdown.querySelectorAll('.custom-dropdown__option').forEach(o => o.classList.remove('is-active'));

      correctFontDropdown.addEventListener('click', function (e) {
        const option = e.target.closest('.custom-dropdown__option');
        if (!option) return;
        clearNativeError('js-engraving-font-error');

        const chosen     = option.dataset.value;
        selectedFontKey  = chosen;
        selectedFont     = FONT_MAP[chosen] || chosen;

        // ====== Update preview font if text already entered ======
        if (preview.textContent.trim().length > 0) {
          preview.style.fontFamily = selectedFont;
          preview.textContent      = previewDisplayText(input.value);
        }
        // ====== In side-option mode Side B has its OWN font, so leave preview2/input2 alone here ======
        if (preview2 && preview2.textContent.trim().length > 0 && placementMode !== 'side-option') {
          preview2.style.fontFamily = selectedFont;
          preview2.textContent = previewDisplayText(input2.value);
        }
        // ====== vert-hor-option mode shares the primary font across all three boxes ======
        if (preview3 && preview3.textContent.trim().length > 0) {
          preview3.style.fontFamily = selectedFont;
          preview3.textContent = previewDisplayText(input3.value);
        }

        correctFontDropdown.querySelectorAll('.custom-dropdown__option').forEach(o => o.classList.remove('is-active'));
        option.classList.add('is-active');
        if (label) label.textContent = chosen;

        syncPropertyToForm('Engraving_Font', chosen);

        // re-sync text properties with correct casing for the newly selected font
        const currentText = input.value;
        if (currentText.trim().length > 0) {
          syncEngravingTextToForm('Engraving_Text', isCelineFont() ? currentText.toUpperCase() : currentText);
        }
        if (input2 && input2.value.trim().length > 0 && placementMode !== 'side-option') {
          syncEngravingTextToForm('Engraving_Text_2', isCelineFont() ? input2.value.toUpperCase() : input2.value);
        }
        if (input3 && input3.value.trim().length > 0) {
          syncEngravingTextToForm('Engraving_Text_3', isCelineFont() ? input3.value.toUpperCase() : input3.value);
        }

        // ====== Dynamic image: update font and fire event ======
        window.__rcEngravingImageData.font = chosen;
        dispatchEngravingSelectionChanged();
      });
    }

    // ====== Font Dropdown listener — Side B (Engraving_Font_2, side-option mode only) ======
    const fontWrapper2         = block.querySelector('[data-engraving-dropdown="Engraving_Font_2"]');
    const correctFontDropdown2 = fontWrapper2 ? fontWrapper2.querySelector('.custom-dropdown') : null;

    if (correctFontDropdown2) {
      const label2 = correctFontDropdown2.querySelector('.custom-dropdown__label');
      if (label2) label2.textContent = 'Select';
      correctFontDropdown2.querySelectorAll('.custom-dropdown__option').forEach(o => o.classList.remove('is-active'));

      correctFontDropdown2.addEventListener('click', function (e) {
        const option = e.target.closest('.custom-dropdown__option');
        if (!option) return;
        clearNativeError('js-engraving-font2-error');

        const chosen     = option.dataset.value;
        selectedFontKey2 = chosen;
        selectedFont2    = FONT_MAP[chosen] || chosen;

        // ====== Update Side B preview font if text already entered ======
        if (preview2 && preview2.textContent.trim().length > 0) {
          preview2.style.fontFamily = selectedFont2;
          preview2.textContent      = previewDisplayText2(input2.value);
        }

        correctFontDropdown2.querySelectorAll('.custom-dropdown__option').forEach(o => o.classList.remove('is-active'));
        option.classList.add('is-active');
        if (label2) label2.textContent = chosen;

        syncPropertyToForm('Engraving_Font_2', chosen);

        // re-sync Side B text with correct casing for the newly selected font
        if (input2 && input2.value.trim().length > 0) {
          syncEngravingTextToForm('Engraving_Text_2', isCelineFont2() ? input2.value.toUpperCase() : input2.value);
        }

        // ====== Dynamic image: track Side B font and fire event ======
        window.__rcEngravingImageData.font2 = chosen;
        dispatchEngravingSelectionChanged();
      });
    }

    // ====== Primary text input handler ======
    input.addEventListener('input', function () {
      clearNativeError('js-engraving-text-error');
      const maxLen = parseInt(this.getAttribute('maxlength')) || defaultMax;
      const text   = this.value.slice(0, maxLen);
      if (this.value !== text) this.value = text;

      const countEl = document.getElementById(`engraving-count-${sectionId}`);
      if (countEl) countEl.textContent = text.length;

      if (text.trim().length > 0) {
        preview.textContent           = previewDisplayText(text);
        preview.style.fontFamily      = selectedFont || 'inherit';
        // ====== Show only the line-1 preview wrapper (sits just below input 1) ======
        if (previewWrapper) previewWrapper.style.display = '';
      } else {
        if (previewWrapper) previewWrapper.style.display = 'none';
        preview.textContent = '';
      }

      syncEngravingTextToForm('Engraving_Text', isCelineFont() ? text.toUpperCase() : text);
    });

    // ====== Secondary text input handler (Side B in side-option mode, "Vertical with Center Dot" box 2, or line 2 elsewhere) ======
    if (input2) {
      input2.addEventListener('input', function () {
        // ====== js-engraving-text2-error exists in side-option and vert-hor-option markup — don't call it for other modes ======
        if (placementMode === 'side-option' || placementMode === 'vert-hor-option') {
          clearNativeError('js-engraving-text2-error');
        }
        const maxLen2 = parseInt(this.getAttribute('maxlength')) || defaultMax2;
        const text2   = this.value.slice(0, maxLen2);
        if (this.value !== text2) this.value = text2;

        const count2El = document.getElementById(`engraving-count2-${sectionId}`);
        if (count2El) count2El.textContent = text2.length;

        // ====== side-option mode uses Side B's own font; other modes (incl. vert-hor-option) share the primary font ======
        const useFont2 = placementMode === 'side-option';

        if (text2.trim().length > 0) {
          if (preview2) {
            preview2.textContent      = useFont2 ? previewDisplayText2(text2) : previewDisplayText(text2);
            preview2.style.fontFamily = (useFont2 ? selectedFont2 : selectedFont) || 'inherit';
          }
          if (previewWrapper2) previewWrapper2.style.display = '';
        } else {
          if (previewWrapper2) previewWrapper2.style.display = 'none';
          if (preview2) preview2.textContent = '';
        }
        const casedText2 = useFont2
          ? (isCelineFont2() ? text2.toUpperCase() : text2)
          : (isCelineFont() ? text2.toUpperCase() : text2);
        syncEngravingTextToForm('Engraving_Text_2', casedText2);
      });
    }

    // ====== Third text input handler (vert-hor-option mode only — "Vertical with Center Dot" third, optional box) ======
    if (input3) {
      input3.addEventListener('input', function () {
        clearNativeError('js-engraving-text3-error');
        const maxLen3 = parseInt(this.getAttribute('maxlength')) || 2;
        const text3   = this.value.slice(0, maxLen3);
        if (this.value !== text3) this.value = text3;

        const count3El = document.getElementById(`engraving-count3-${sectionId}`);
        if (count3El) count3El.textContent = text3.length;

        if (text3.trim().length > 0) {
          if (preview3) {
            preview3.textContent      = previewDisplayText(text3);
            preview3.style.fontFamily = selectedFont || 'inherit';
          }
          if (previewWrapper3) previewWrapper3.style.display = '';
        } else {
          if (previewWrapper3) previewWrapper3.style.display = 'none';
          if (preview3) preview3.textContent = '';
        }

        syncEngravingTextToForm('Engraving_Text_3', isCelineFont() ? text3.toUpperCase() : text3);
      });
    }

    // ====== Sync helpers ======
    function syncPropertyToForm(propertyName, value) {
      const form = getEngravingForm(sectionId);
      if (!form) return;
      let hiddenInput = form.querySelector(`input[name="properties[${propertyName}]"]`);
      if (!hiddenInput) {
        hiddenInput      = document.createElement('input');
        hiddenInput.type = 'hidden';
        hiddenInput.name = `properties[${propertyName}]`;
        form.appendChild(hiddenInput);
      }
      hiddenInput.value = value;
    }

    function syncEngravingTextToForm(propertyName, text) {
      const form = getEngravingForm(sectionId);
      if (!form) return;

      let hiddenInput = form.querySelector(`input[name="properties[${propertyName}]"]`);
      if (text.trim().length > 0) {
        if (!hiddenInput) {
          hiddenInput      = document.createElement('input');
          hiddenInput.type = 'hidden';
          hiddenInput.name = `properties[${propertyName}]`;
          form.appendChild(hiddenInput);
        }
        hiddenInput.value = text;
      } else {
        if (hiddenInput) hiddenInput.remove();
      }
    }

    // ====== Validation — runs BEFORE product-form.js via capture phase ======
    window.__rcEngraving = {
      validate: (e) => {
        const form = getEngravingForm(sectionId);
        if (!form) return true;

        // ====== Clear all engraving error messages at the start of every attempt ======
        // so leftovers from a previous click don't linger once the user has moved on.
        ['js-engraving-placement-error', 'js-engraving-font-error', 'js-engraving-font2-error',
        'js-engraving-text-error', 'js-engraving-text2-error', 'js-engraving-text3-error'].forEach(clearNativeError);

        if (!toggle || !toggle.checked) {
          let engravingRequired = form.querySelector('input[name="properties[_engraving_required]"]');
          if (!engravingRequired) {
            engravingRequired      = document.createElement('input');
            engravingRequired.type = 'hidden';
            engravingRequired.name = 'properties[_engraving_required]';
            form.appendChild(engravingRequired);
          }
          engravingRequired.value = 'No';
          return true;
        }

        // ====== side-option mode: independent Side A / Side B validation ======
        if (placementMode === 'side-option') {
          const fontAInput = form.querySelector('input[name="properties[Engraving_Font]"]');
          const fontBInput = form.querySelector('input[name="properties[Engraving_Font_2]"]');
          const hasFontA = !!(fontAInput && fontAInput.value);
          const hasFontB = !!(fontBInput && fontBInput.value);
          const textA = input.value.trim();
          const textB = input2 ? input2.value.trim() : '';

          // ====== Nothing selected/entered on either side: flag BOTH fonts as required ======
          if (!hasFontA && !hasFontB && !textA && !textB) {
            showNativeError('Please select Font for Side A to proceed to cart.', 'js-engraving-font-error');
            showNativeError('Please select Font for Side B to proceed to cart.', 'js-engraving-font2-error');
            return false;
          }

          // ====== Side A: font chosen but no text yet -> text-A error only ======
          if (hasFontA && !textA) {
            showNativeError('Please enter Customization text for Side A to proceed to cart.', 'js-engraving-text-error');
            input.focus();
            return false;
          }
          // ====== Side A: text typed but no font chosen -> font-A error only ======
          if (textA && !hasFontA) {
            showNativeError('Please select Font for Side A to proceed to cart.', 'js-engraving-font-error');
            return false;
          }

          // ====== Side B: font chosen but no text yet -> text-B error only ======
          if (hasFontB && !textB) {
            showNativeError('Please enter Customization text for Side B to proceed to cart.', 'js-engraving-text2-error');
            return false;
          }
          // ====== Side B: text typed but no font chosen -> font-B error only ======
          if (textB && !hasFontB) {
            showNativeError('Please select Font for Side B to proceed to cart.', 'js-engraving-font2-error');
            return false;
          }

          // ====== Safety net: neither side ended up fully complete ======
          if (!(hasFontA && textA) && !(hasFontB && textB)) {
            showNativeError('Please enter Customization text for at least one side to proceed to cart.', 'js-engraving-text-error');
            input.focus();
            return false;
          }

          let engravingRequired = form.querySelector('input[name="properties[_engraving_required]"]');
          if (!engravingRequired) {
            engravingRequired      = document.createElement('input');
            engravingRequired.type = 'hidden';
            engravingRequired.name = 'properties[_engraving_required]';
            form.appendChild(engravingRequired);
          }
          engravingRequired.value = 'Yes';
          return true;
        }

        // ====== Validate placement/style/vert-hor selection (if applicable) ======
        if (placementMode === 'style-option' || placementMode === 'placement-option' || placementMode === 'vert-hor-option') {
          const placementInput = form.querySelector('input[name="properties[_engravingplacement]"]');
          if (!placementInput || !placementInput.value) {
            const errLabel = placementMode === 'style-option' ? 'Engraving Style' : 'Engraving Placement';
            showNativeError(`Please select ${errLabel} to proceed to cart.`, 'js-engraving-placement-error');
            return false;
          }
        }

        // ====== Validate font ======
        const fontInput = form.querySelector('input[name="properties[Engraving_Font]"]');
        if (!fontInput || !fontInput.value) {
          showNativeError('Please select Engraving Font to proceed to cart.', 'js-engraving-font-error');
          return false;
        }

        // ====== Validate primary text ======
        const engravingText = input.value.trim();
        if (!engravingText) {
          showNativeError('Please enter Customization text to proceed to cart.', 'js-engraving-text-error');
          input.focus();
          return false;
        }

        // ====== vert-hor-option mode: "Vertical with Center Dot" also requires text 2 (text 3 stays optional) ======
        if (placementMode === 'vert-hor-option') {
          const placementInput  = form.querySelector('input[name="properties[_engravingplacement]"]');
          const chosenPlacement = placementInput ? placementInput.value : '';
          if (chosenPlacement === 'Vertical with Center Dot') {
            const text2Val = input2 ? input2.value.trim() : '';
            if (!text2Val) {
              showNativeError('Please enter Customization text to proceed to cart.', 'js-engraving-text2-error');
              if (input2) input2.focus();
              return false;
            }
          }
        }

        // ====== All good — mark engraving required ======
        let engravingRequired = form.querySelector('input[name="properties[_engraving_required]"]');
        if (!engravingRequired) {
          engravingRequired      = document.createElement('input');
          engravingRequired.type = 'hidden';
          engravingRequired.name = 'properties[_engraving_required]';
          form.appendChild(engravingRequired);
        }
        engravingRequired.value = 'Yes';
        return true;
      }
    };
  }

  // ====== Init all engraving instances on page ======
  document.querySelectorAll('.engraving-config').forEach(configEl => {
    initEngravingToggle(configEl);
    initEngraving(configEl);
  });

})();